import { NullableClassName, ChildrenProp } from '@squareup/dex-types-shared-ui';
import { ColorVariants, Paragraph30 } from '@squareup/dex-ui-shared-base';
import clsx from 'clsx';
import React, { FC } from 'react';

import { Link } from '../Link';

import styles from './eyebrow.module.css';

interface EyebrowArgs {
  backHref?: React.ComponentProps<typeof Link>['href'] | undefined;
}

const EyebrowText: FC<NullableClassName & ChildrenProp & ColorVariants> = ({
  className,
  children,
  colorVariant,
}) => (
  <Paragraph30
    colorVariant={colorVariant}
    className={clsx(styles.eyebrow, className)}
  >
    {children}
  </Paragraph30>
);

const Eyebrow: FC<
  EyebrowArgs & NullableClassName & ChildrenProp & ColorVariants
> = ({ backHref, className, children, colorVariant = '20' }) => {
  return backHref ? (
    <>
      <Link
        className={styles.narrow}
        href={backHref}
        disableTextDecoration={true}
        trackingId="eyebrow-back-arrow"
      >
        <EyebrowText className={className} colorVariant={colorVariant}>
          {'<-'} {children}
        </EyebrowText>
      </Link>
      <EyebrowText
        className={clsx(styles.desktop, className)}
        colorVariant={colorVariant}
      >
        {children}
      </EyebrowText>
    </>
  ) : (
    <EyebrowText className={className}>{children}</EyebrowText>
  );
};

export { Eyebrow };
